'use strict';

var FlightLegCabinDtdFilterFactory = function FlightLegCabinDtdFilterFactory(DataFilter) {
  function FlightLegCabinDtdFilter() {
    DataFilter.call(this, 'class', 'profileChart');
  }
  FlightLegCabinDtdFilter.prototype = Object.create(DataFilter.prototype);
  FlightLegCabinDtdFilter.prototype.filter = function (data, filterArgsArray) {
    if (Array.isArray(filterArgsArray) && filterArgsArray.length >= 1) {
      var filter = filterArgsArray[0];
      var field = filter.metric === 'bookings' ? 'booking' : 'revenue';
      var tempArray = data;
      tempArray = tempArray.map(function (element) {
        var elementm2;
        var curvesLength = [];
        element.m1 = element.m2 = element.m3 = element.m4 = undefined;
        if (element.m1curve) {
          curvesLength.push(element.m1curve.length);
        }
        if (Array.isArray(element.m2curve)) {
          curvesLength.push(element.m2curve.length);
        }
        if (element.m3curve) {
          curvesLength.push(element.m3curve.length);
        }
        if (element.m4curve) {
          curvesLength.push(element.m4curve.length);
        }
        var maxLength = Math.max.apply(this, curvesLength);
        for (var i = 0; i < maxLength; i++) {
          if (Array.isArray(element.m1curve) && element.m1curve[i] !== undefined && element.m1curve[i].daysToDeparture === filter.daysToDeparture) {
            element.m1 = element.m1curve[i][field];
          }
          if (Array.isArray(element.m2curve) && element.m2curve[i] !== undefined && element.m2curve[i].daysToDeparture === 0) {
            element.m2 = elementm2 = element.m2curve[i][field];
          }
          if (Array.isArray(element.m3curve) && element.m3curve[i] !== undefined && element.m3curve[i].daysToDeparture === filter.daysToDeparture) {
            element.m3 = element.m3curve[i][field];
          }
          if (Array.isArray(element.m4curve) && element.m4curve[i] !== undefined && element.m4curve[i].daysToDeparture === 0) {
            element.m4 = element.m4curve[i][field];
          }
        }
        if (!Array.isArray(element.m2curve)) {
          element.m2 = element.m2curve;
        } else if (Array.isArray(element.m2curve) && elementm2 === undefined) {
          element.m2 = 0;
        }

        // data curves for individual classes may not contain all data points for given date to departure
        // that's why we need to replace undefined with 0 or implement correct handling of undefined in graph
        element.m1 = element.m1 === undefined ? 0 : element.m1;
        if (Array.isArray(element.m3curve) && Array.isArray(element.m4curve)) {
          element.m3 = element.m3 === undefined ? 0 : element.m3;
          element.m4 = element.m4 === undefined ? 0 : element.m4;
        }
        return element;
      });
      return tempArray;
    } else {
      return data;
    }
  };
  return FlightLegCabinDtdFilter;
};
FlightLegCabinDtdFilterFactory.$inject = ['DataFilterFactory'];
module.exports = FlightLegCabinDtdFilterFactory;